import { HAS_WINDOW } from '@eb/feature-detection';

const MIN_DEVICE_MEDIA_QUERY =
    '(-webkit-min-device-pixel-ratio: 1.5), (min-device-pixel-ratio: 1.5), (min-resolution: 144dpi), (min-resolution: 1.5dppx)';

/**
 * Safely, determine if the device has a retina screen
 */
export const hasRetinaScreen = () =>
    HAS_WINDOW && window.matchMedia(MIN_DEVICE_MEDIA_QUERY).matches;
